export const OPTIONS = {
	NONE: 'invalid',
	VTK_DATA_REFRESH: 'VTKDataRefresh',
	S12_THRESHOLDS_UPDATE: 'S12ThresholdsUpdate',
	CREATE_XML_TOPOLOGY: 'CreateXMLTopology',
	TRAFFIC_TRENDS_DATA_REFRESH: 'TrafficTrendsDataRefresh',
};

export const MENU_ITEMS_CONFIG = [
	{
		// Unified screen: Manual Upload / From E-mail / From OneDrive, plus the shared
		// VTKImportLock status (and, for Administrators, the force-release action).
		value: OPTIONS.VTK_DATA_REFRESH,
		text: 'VTK Data Refresh',
		allowedRoles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS'],
		allowedProjects: ['VMO2 Ran'],
		project: 'VMO2 Ran',
	},
	{
		value: OPTIONS.S12_THRESHOLDS_UPDATE,
		text: 'S12 Thresholds History Update',
		allowedRoles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS'],
		allowedProjects: ['VMO2 Ran'],
		project: 'VMO2 Ran',
	},
	{
		value: OPTIONS.CREATE_XML_TOPOLOGY,
		text: 'Create XML Topology From FTP',
		allowedRoles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS'],
		allowedProjects: ['VMO2 Ran'],
		project: 'VMO2 Ran',
	},
	{
		value: OPTIONS.TRAFFIC_TRENDS_DATA_REFRESH,
		text: 'Traffic Trends Data Refresh',
		allowedRoles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS'],
		allowedProjects: ['VMO2 Radio Design'],
		project: 'VMO2 Radio Design',
	},
];
